import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import Login from "./pages/Auth/LoginPage";
import ForgotPassword from "./pages/Auth/ForgotPasswordPage";
import Dashboard from "./pages/Dashboard/DashboardPage";
import AllEvents from "./pages/Events/AllEvents";
import CategoriesPage from "./pages/Categories/CategoriesPage";
import ProtectedRoute from "./components/Auth/ProtectedRoute";

export default function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: '"Libre Franklin", sans-serif',
          colorText: "#000738",
          fontSizeHeading1: "2.625rem", // 42px
          fontSizeHeading2: "1.5rem", // 32px
          fontSizeHeading3: "1.25rem", // 24px
          fontSizeHeading4: "1.125rem", // 18px
          fontSizeHeading5: "0.875rem", // 14px
          // controlHeight: 50,
          // controlHeightLG: 50,
        },
        components: {
          Button: {
            controlHeight: 42,
            controlHeightLG: 42,
            contentFontSize: 16,
          },
          Menu: {
            itemHoverBg: "#F1F6FF",
            itemActiveBg: "#F1F6FF",
            itemHoverColor: "#61A0FF",
          },
          Input: {
            paddingInline: 12,
            colorBorder: "#D9D9D9",
            hoverBorderColor: "#61a0ff",
            colorTextPlaceholder: "rgba(113, 113, 113, 0.65)",
            colorText: "#000738",
            controlHeightLG: 42,
          },
          DatePicker: {
            colorBorder: "#D9D9D9",
            hoverBorderColor: "#61a0ff",
            colorTextPlaceholder: "rgba(0, 0, 0, 0.65)",
            colorText: "#000738",
            controlHeightLG: 42,
          },
          Select: {
            colorBorder: "#D9D9D9",
            hoverBorderColor: "#61a0ff",
            colorTextPlaceholder: "rgba(0, 0, 0, 0.65)",
            colorText: "#000738",
            optionActiveBg: "#f1fbff",
            optionSelectedBg: "#f1fbff",
            optionSelectedColor: "#61a0ff",
            optionSelectedFontWeight: 500,
            controlHeightLG: 42,
          },
          Dropdown: {
            controlItemBgHover: "#f1fbff",
            controlItemBgActive: "#f1fbff",
            fontSize: "0.875rem",
            paddingBlock: 4,
            fontSizeIcon: 24,
          },
          Tag: {
            borderRadiusSM: 30,
          },
          Tabs: {
            cardBg: "transpatent",
            colorBorderSecondary: "transpatent",
            cardPadding: "14px 24px",
            fontSize: 16,
          },
          Upload: {
            colorBorder: "#D9D9D9",
            hoverBorderColor: "#61a0ff",
            lineType: "solid",
          },
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/all-events" element={<AllEvents />} />
            <Route path="/categories" element={<CategoriesPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["guest"]} />}>
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}
